import { render, staticRenderFns } from "./Stories.vue?vue&type=template&id=eba40996&"
import script from "./Stories.vue?vue&type=script&lang=ts&"
export * from "./Stories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports